import { useEffect, useState, useRef, } from 'react';

import { Button, Form, Col, InputGroup, } from 'react-bootstrap';
import { CircularProgress, } from '@material-ui/core';
import { Toggle } from 'rsuite';;
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';

import AddIcon from '@material-ui/icons/Add';

import ToastAnimated, { showToast } from '../../ui-lib/toast';
import 'react-toastify/dist/ReactToastify.css';

import api, { listTicketTypes, listCompanies, listUsers, } from '../../services/api';

import './newChamadoStyles.css';

import TicketTypeManagementModal from '../TicketTypeManagementModal';

import useModal from '../../hooks/useModal';


const useStyles = makeStyles((theme) => ({
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -10,
  },
}));


export default function NewChamadoComponent({ onClose }) {
  const ticketTypeManagementModal = useModal(() => {}, () => getTicketTypes());
  //Variaveis formulario
  const [idEmpresa, setIdEmpresa] = useState('')
  const [requerente, setRequerente] = useState('')
  const [chamado, setChamado] = useState('')
  const [getNatureza, setGetNatureza] = useState('')
  const [tecnico, setTecnico] = useState('Robson Rosa')
  const [assunto, setAssunto] = useState('')
  const [temp_g, setTemp_g] = useState('')

  const [checked, setCheked] = useState();
  const colorCheck = checked ? "#00B2A6" : " ";
  const statusChamado = checked ? 'Aberto' : 'Concluido';

  //Variaveis consulta
  const [empresas, setEmpresas] = useState([])
  const [natureza, setNatureza] = useState([])

  const data = new Date()
  const classes = useStyles()
  const [statusSalvar, setStatusSalvar] = useState('Salvar')
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)

  const timer = useRef();


  function refreshPage(info) {
    window.location.reload(info)
  }

  function initialize() {
    listUsers()
      .then(({ data, }) => {
        setUsers(data);
      });

    listCompanies(true)
      .then(({ data, }) => {
        setEmpresas(data);
      });

    getTicketTypes();
  }

  function getTicketTypes() {
    listTicketTypes()
      .then(({ data, }) => {
        setNatureza(data);
      });
  }

  useEffect(() => {
    initialize();
  }, []);

  const handleButtonClick = () => {
    if (!requerente) {
      return showToast({
        type: 'error',
        message: 'Nome não pode ser vazio',
      });
    } else if (!chamado) {
      return showToast({
        type: 'error',
        message: 'O Chamado deve ter um corpo',
      });
    } else if (!idEmpresa) {
      return showToast({
        type: 'error',
        message: 'A empresa nao pode ser vazia',
      });
    }

    if (!loading) {
      setLoading(true);
      setStatusSalvar('Salvando');

      api
        .post('/chamados', {
          idEmpresa: idEmpresa,
          id_user: requerente,
          tipo_chamado: getNatureza,
          requerente: '',
          prioridade: '',
          corpo_chamado: chamado,
          assunto: assunto,
          tecnico: tecnico,
          status: statusChamado,
          data_abertura: data,
          temp_g: temp_g,
          resolveObs: '',
          resolv: '',
        })
        .then(() => {
          timer.current = window.setTimeout(() => {
            setStatusSalvar('Salvo');
            refreshPage();
          }, 1000);
        })
        .catch(({ data }) => {
          console.log(data);
          return showToast({
            type: 'error',
            message: 'Erro ao criar ao criar chamado',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }


  return (
    <div>
      <div className="ContainerNewChamado">
        <h5>
          Novo chamado
        </h5>
        <Form className="formContent">
          <div className="formLeft">
            <Form.Group>
              <Form.Label className="labelInputs">
                Assunto do chamado *
              </Form.Label>
              <Form.Control
                value={assunto}
                onChange={(event) => {
                  setAssunto(event.target.value)
                }}
                className="inputCampo"
                placeholder="Assunto do chamado"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label className="labelInputs">
                Nome
              </Form.Label>
              <Form.Control
                value={requerente}
                onChange={(event) => {
                  setRequerente(event.target.value)
                }}
                className="inputCampo"
              />
            </Form.Group>

            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label className="labelInputs">
                  Empresa *
                </Form.Label>
                <Form.Control
                  as="select"
                  value={idEmpresa}
                  onChange={(event) => {
                    setIdEmpresa(event.target.value)
                  }}
                  placeholder="Nome"
                  className="inputCampo"
                >
                  <option>
                    Escolha...
                  </option>
                  {
                    empresas
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((empresa) => {
                        return (
                          <option key={empresa._id} >
                            {empresa.name}
                          </option>
                        );
                      })
                  }
                </Form.Control>
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label className="labelInputs">
                  Natureza do Chamados
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    value={getNatureza}
                    onChange={(event) => {
                      setGetNatureza(event.target.value)
                    }}
                    className="inputCampo"
                    as="select"
                    defaultValue="Escolha...."
                  >
                    <option>
                      Escolha...
                    </option>
                    {
                      natureza
                        .sort((a, b) => a.type.localeCompare(b.type))
                        .map((ticketType) => {
                          return (
                            <option key={ticketType.id}>
                              { ticketType.type }
                            </option>
                          );
                        })
                    }
                  </Form.Control>
                  <InputGroup.Append>
                    <Button
                      variant="outline-dark"
                      onClick={() => ticketTypeManagementModal.onOpen()}
                    >
                      <AddIcon fontSize="small" />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                controlId="formGridZip"
              >
                <Form.Label className="labelInputs">
                  Técnico Responsável
                </Form.Label>
                <Form.Control
                  className="inputCampo"
                  value={tecnico}
                  onChange={(event) => {
                    setTecnico(event.target.value)
                  }}
                  as="select"
                  defaultValue="Escolha..."
                >
                  <option>
                    Escolha...
                  </option>
                  {
                    users
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((users) => {
                        return (
                          <option key={users._id}>
                            {users.name}
                          </option>
                        );
                      })
                  }
                </Form.Control>
              </Form.Group>
            </Form.Row>
          </div>

          <div className="formRight">
            <Form.Label className="labelInputs">
              Descrição do chamado *
            </Form.Label>
            <Form.Control
              value={chamado}
              onChange={(event) => {
                setChamado(event.target.value)
              }}
              className="inputCampo"
              as="textarea"
              rows={5}
              placeholder="Escreva aqui a solicitação"
            />

            <br/>

            <Form.Row>
              <Form.Group className="minutosInput" as={Col}>
                <Form.Label className="labelInputs">
                  Tempo gasto (minutos)
                </Form.Label>
                <Form.Control
                  type="number"
                  value={temp_g}
                  onChange={(event) => {
                    setTemp_g(event.target.value)
                  }}
                  className="inputCampo"
                />
              </Form.Group>
              <div className="toggleStatus">
                <Toggle
                  size="lg"
                  style={{
                    background:`${colorCheck}`,
                  }}
                  value={checked}
                  checkedChildren="Aberto"
                  unCheckedChildren="Concluido"
                  onChange={(checked, event) => {
                    setCheked(checked)
                  }}
                />
              </div>
            </Form.Row>
          </div>
        </Form>
      </div>

      <div className="boxButtonBotton">
        <ToastAnimated />
        <button
          className="BTN-CancelChamado"
          disabled={loading}
          onClick={onClose}
        >
          Cancelar
        </button>

        <button
          className="BTN-SaveChamado"
          disabled={loading}
          onClick={handleButtonClick}
        >
          {statusSalvar}
        </button>
        {loading && (
          <CircularProgress
            size={24}
            className={classes.buttonProgress}
          />
        )}
      </div>

      <TicketTypeManagementModal
        open={ticketTypeManagementModal.value}
        onClose={ticketTypeManagementModal.onClose}
      />
    </div>
  );
}
